/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import useForm from '../../customHooks/useForm';
import useToast from '../../customHooks/useToast';
import { ADMIN_REJECT_DOCUMENT } from '../../graphql/admin_mutations';
import RejectFileIcon from '../../svgs/RejectFileIcon';
import TextInput from '../input';
import ModalFormComp from '../ModalFormComp';
import StyledButton from '../StyledButton';
import './RejectFile.scss';

interface IRejectFile{
  closeModal?:any;
  payload?:any;
  fetchKyc?:any;
  rejectDocumentType?:string;
  fetchUser?:any;
  id?:string;
}
const RejectFile = ({
  closeModal, payload, fetchKyc, rejectDocumentType, fetchUser, id,
}:IRejectFile) => {
  const Toast = useToast();
  const [rejectDocument] = useMutation<
  { rejectDocumentCa: any },
  any
>(ADMIN_REJECT_DOCUMENT);
  const [RejectLoading, setRejectLoading] = useState(false);
  const {
    formValues, resetForm, handleChange,
  } = useForm(
    {
      reason: '',
    },
    {},
    Toast,
  );
  const handleReject = async () => {
    try {
      setRejectLoading(true);
      if (!formValues?.reason) {
        setRejectLoading(false);
        return Toast.error('Please provide a reason for rejection');
      }
      const res = await rejectDocument({
        variables: { id: payload?.id, message: formValues?.reason },
      });

      if (res?.data?.rejectDocumentCa?.status === 200) {
        Toast.success(res?.data?.rejectDocumentCa?.message);
        setRejectLoading(false);
        resetForm({ reason: '' });

        closeModal();
        rejectDocumentType ? fetchUser?.({ variables: { id } }) : fetchKyc?.();
        return;
      }
      Toast.error(res?.data?.rejectDocumentCa?.message);
    } catch (e) {
      if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
        Toast.error(e.graphQLErrors[0].message);
      } else {
        Toast.error('Something went wrong');
      }
      resetForm({ reason: '' });
    }
    setRejectLoading(false);
  };
  return (
    <ModalFormComp closeModal={closeModal} removeTitle modalType="reject-modal">
      <div className="reject-file-cover">
        <div className="reject-file-icon"><RejectFileIcon /></div>
        <div className="reject-file-title">Confirm Rejection</div>
        <div className="reject-file-subtitle">
          Please enter a reason for your rejection
        </div>
        <div>
          <TextInput rows={3} name="reason" value={formValues?.reason} multiline placeholder="Reason for rejection" customOnChange={handleChange} />
        </div>
        <div>
          <StyledButton name={RejectLoading ? 'Loading...' : 'Reject'} backgroundColor="black" width="100%" height="31px" borderRadius="4px" color="white" fontSize="12px" onClick={handleReject} disabled={!!RejectLoading} />
        </div>
        <div>
          <StyledButton name="Cancel" backgroundColor="white" width="100%" height="31px" borderRadius="4px" color="#98A2B3" fontSize="12px" onClick={closeModal} border="1px solid #98A2B3" />
        </div>
      </div>

    </ModalFormComp>
  );
};
export default RejectFile;
